<template>
  <div class="video-label">
    <!-- 视频源 -->
    <video
      ref="videoRef"
      :src="fileUrl"
      controls
      playsinline
      style="width: 100%; max-width: 600px; margin: 0 auto; display: block"
    />

    <!-- 波形 -->
    <div id="waveform"></div>
    <!-- <div id="minimap"></div> -->

    <!-- 区域列表 -->

    <div class="region-list">
      <div
        class="region-item"
        v-for="(item, index) in regionList"
        :key="item.id"
        :style="{ backgroundColor: item.color }"
      >
        <div>{{ index + 1 }}. {{ item.content }}</div>
        <div>
          {{ item.start.toFixed(2) }} - {{ item.end.toFixed(2) }}
          <i class="el-icon-video-play" @click="playRegion(item.region)"></i>
          <i class="el-icon-delete" @click="deleteRegion(item.region)"></i>
        </div>
      </div>
    </div>

    <!-- 虚拟锚点 -->

    <el-popover
      v-model="popoverVisible"
      virtual-triggering
      trigger="manual"
      placement="right-start"
      width="120"
    >
      <div class="menu-item" @click="playRegion(clickRegion)">播放</div>
      <div class="menu-item danger" @click="deleteRegion(clickRegion)">
        删除
      </div>
      <div
        slot="reference"
        ref="popoverRef"
        class="popover-anchor"
        :style="{ left: menuX + 'px', top: menuY + 'px' }"
      ></div>
    </el-popover>
  </div>
</template>
<script>
import WaveSurfer from "wavesurfer.js";
import RegionsPlugin from "wavesurfer.js/dist/plugins/regions.esm.js";
import TimelinePlugin from "wavesurfer.js/dist/plugins/timeline.esm.js";
import MinimapPlugin from "wavesurfer.js/dist/plugins/minimap.esm.js";
import { Message } from "element-ui";

export default {
  name: "WaveRegion",

  props: {
    value: {
      required: true
    },
    fileUrl: {
      type: String,
      required: true
    },
    labelValue: {
      type: Object,
      required: false
    },
    labelOptions: {
      required: false
    }
  },

  data() {
    return {
      ws: null,
      regions: RegionsPlugin.create(),
      regionList: [],
      popoverVisible: false,
      clickRegion: null,
      menuX: 0,
      menuY: 0,
      // 是否正在回显
      isRestoring: false
    };
  },
  watch: {
    labelOptions: {
      immediate: true,
      deep: true,
      handler(val) {
        const ids = val.map(i => i.label);
        console.log(this.regionList);
        this.regionList.forEach(item => {
          console.log(item.params.label, ids, ids.includes(item.params.label));
          if (!ids.includes(item.params.label)) {
            item.region.remove();
          }
        });
        this.regionList = this.regionList.filter(i =>
          ids.includes(i.params.label)
        );
        this.$emit("input", this.regionList);
      }
    }
  },
  mounted() {
    this.initWave();
  },

  methods: {
    hexToRgba(hex, alpha = 0.8) {
      let h = hex.replace("#", "");
      if (h.length === 3) {
        h = h
          .split("")
          .map(c => c + c)
          .join("");
      }
      const r = parseInt(h.slice(0, 2), 16);
      const g = parseInt(h.slice(2, 4), 16);
      const b = parseInt(h.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },

    initWave() {
      const timeline = TimelinePlugin.create();

      this.ws = WaveSurfer.create({
        container: "#waveform",
        url: this.fileUrl,
        media: this.$refs.videoRef,
        minPxPerSec: 10,
        autoScroll: false, // 关键
        autoCenter: false, // 关键
        waveColor: "#c6e2ff",
        progressColor: "#409eff",
        scrollParent: true,
        plugins: [this.regions, timeline]
      });

      /** ⭐ 只有存在 labelValue 才允许标注 */

      this.regions.enableDragSelection({
        color: "rgba(115,118,122,0.4)"
      });

      this.regions.on("region-created", this.onRegionCreated);
      this.regions.on("region-updated", this.onRegionUpdated);
      this.regions.on("region-clicked", this.onRegionClicked);
    },
    setOptions(data) {
      this.isRestoring = true;
      data.forEach(item => {
        console.log("item", item);
        this.regions.addRegion({ ...item, color: this.hexToRgba(item.color) });
      });
      this.$nextTick(() => {
        this.isRestoring = false;
        this.$emit("input", this.regionList);
      });
    },
    bindMinimapWheelZoom() {
      const minimapEl = document.querySelector("#minimap");
      if (!minimapEl || !this.ws) return;

      minimapEl.addEventListener(
        "wheel",
        e => {
          e.preventDefault();

          const delta = e.deltaY > 0 ? -20 : 20;
          let px = this.ws.params.minPxPerSec + delta;

          px = Math.max(20, Math.min(px, 500)); // 限制缩放范围

          this.ws.zoom(px);
        },
        { passive: false }
      );
    },
    onRegionCreated(region) {
      if (this.isRestoring) {
        console.log("region", region);
        const params = this.labelOptions.find(
          i => i.label === region.content.textContent
        );
        this.regionList.push({
          id: region.id,
          start: region.start,
          end: region.end,
          params,
          content: region.content.textContent,
          color: region.color,
          region
        });
        return;
      }
      if (!this.labelValue) {
        region.remove();
        Message.warning("请先选择标签");
        return;
      }
      const label = this.labelValue;
      if (!region.content) {
        region.setContent(label.label);
        region.setOptions({
          color: this.hexToRgba(label.color),
          className: "drag-select-region"
        });
      }

      this.regionList.push({
        id: region.id,
        start: region.start,
        end: region.end,
        params: label,
        content: region.content.textContent,
        color: region.color,
        region
      });
      this.$emit("input", this.regionList);
    },

    onRegionUpdated(region) {
      const item = this.regionList.find(i => i.id === region.id);
      if (!item) return;
      item.start = region.start;
      item.end = region.end;

      this.$emit("input", this.regionList);
    },

    onRegionClicked(region, e) {
      this.popoverVisible = false;
      e.preventDefault();
      e.stopPropagation();
      this.clickRegion = region;
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.$nextTick(() => (this.popoverVisible = true));
    },

    playRegion(region) {
      if (!region || !this.ws) return;
      this.ws.pause();
      this.ws.setTime(region.start);
      setTimeout(() => {
        this.ws.play();
      }, 50);

      const handler = time => {
        if (time >= region.end) {
          this.ws.pause();
          this.ws.un("audioprocess", handler);
        }
      };
      this.ws.on("audioprocess", handler);
      this.popoverVisible = false;
    },

    deleteRegion(region) {
      if (!region) return;
      region.remove();
      this.regionList = this.regionList.filter(item => item.id !== region.id);
      this.popoverVisible = false;

      this.$emit("input", this.regionList);
    }
  }
};
</script>
<style scoped lang="less">
.video-label {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

video {
  height: 200px;
  flex: 1;
}
#region,
#waveform,
#timeline,
#minimap {
  margin-top: 8px;
  width: 100%;
}
.popover-anchor {
  position: fixed;
  width: 0;
  height: 0;
}

.menu-item {
  padding: 6px 10px;
  cursor: pointer;
}
.menu-item:hover {
  background: #f5f7fa;
}
.menu-item.danger {
  color: #f56c6c;
}

.region-list {
  margin-top: 16px;
  flex: 1;
  overflow-y: auto;
}
.region-item {
  display: flex;
  justify-content: space-between;
  padding: 8px;
  margin-bottom: 6px;
  color: #000;
}

.label-list {
  padding: 16px;
}
.label-item {
  padding: 8px;
  margin-bottom: 8px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.label-item.is-active {
  outline: 2px solid #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoLabel.vue